export default [
    {
        key: 'display',
        components: [
            {
                key: 'modalEdit',
                ignore: true,
            },
            {
                key: 'tableView',
                ignore: true,
            },
            {
                key: 'autofocus',
                ignore: true,
            },
            {
                key: 'tabindex',
                ignore: true,
            },
            {
                key: 'placeholder',
                ignore: true,
            },
        ],
    },
];
